<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <form class="form w-100" id="kt_step_form" @submit.prevent="saveChange">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{  $t('events.forms.add_step')  }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
            <div class="modal-body"> 
              <div class="row">
                <div class="col-12">
                    <Input
                        :name="`${id}-desc`"
                        type="text"
                        :label="$t('events.forms.step_name')"
                        :isRequired="true" size="lg"
                        v-model="formData.name"
                    />
                </div>
                
              </div>
             
              <div class="form-group">
                <label class="form-label fs-6 text-black">{{ $t('events.forms.description') }}</label>
                <textarea v-model="formData.description" class="form-control form-control-solid" rows="3" ></textarea>
              </div>
              <br>
              <div class="d-flex flex-stack mb-8">
                <div class="me-5">
                  <label class="fs-6 fw-bold">{{ $t('events.forms.repeatable_step') }}</label>
                  <div class="fs-7 fw-bold text-muted">{{$t('events.forms.repeatable_text')}}</div>
                </div>
                <BooleanInput classname="m" name="required" v-model="formData.repeatable" label="events.forms.repeatable" :required="false"/>
              </div>
            </div>
            <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :loading="loading"></Button>
            </div>
          </div>
        </div>
      </form> 
    </div>
  
  </template>
  
  <script setup>
  /* eslint-disable */
  import { useLocales } from "@/composables/locales";
  import {computed, ref, defineProps, onMounted, watch} from "vue";
  import {useStore} from "vuex";
  import Input from "../Input.vue";
  import Select2 from "../Select2.vue";
  import Button from "../Button.vue";
import BooleanInput from "./BooleanInput.vue";
 
  
  const store = useStore()
  const { locale } = useLocales()
  const props = defineProps({
    form: {
      type: Object,
      default: {
        name: "",
        description: "",
        repeatable: false,
        order: 0,
      }
    },
    steps: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    }
  })
  const emits = defineEmits(['save'])
  const formData = ref(props.form)
  
  
  watch(() => props.form, () => {
    if(props.form){
      formData.value = props.form
    }
  
  },{deep: true})
  
  onMounted(() => {})
  
  function closeModal(){
    $('#'+props.id).modal('toggle')
  }
  
  const saveChange = () => {
    emits('save')
    closeModal()
  }
  
  </script>
  
  <style scoped>
  .role {
    border: 1px solid #fff;
    box-shadow: 0 .1rem 1rem .25rem rgba(0, 0, 0, .05);
  }
  </style>